(function () {
  function initSlideshow2Slider() {
    console.log("initSlideshow2Slider");
    const sliderEls = document.querySelectorAll(".slideshow-2__container");

    if (typeof BlazeSlider === "undefined") {
      setTimeout(initSlideshow2Slider, 100);
      return;
    }

    sliderEls.forEach(function (sliderEl) {
      if (sliderEl.blazeSlider) {
        return;
      }

      const autoplay = sliderEl.dataset.autoplay;
      console.log("autoplay", autoplay);

      try {
        new BlazeSlider(sliderEl, {
          all: {
            slidesToShow: 1,
            slidesToScroll: 1,
            loop: true,
            enableAutoplay: autoplay === "true" ? true : false,
            autoplaySpeed: 5000,
            transitionDuration: 500,
            transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
            hoverPause: true,
          },
        });
      } catch (error) {
        console.error("Error initializing BlazeSlider:", error);
      }
    });
  }

  function waitForBlazeSlider() {
    if (typeof BlazeSlider !== "undefined") {
      initSlideshow2Slider();
    } else {
      setTimeout(waitForBlazeSlider, 50);
    }
  }

  function init() {
    waitForBlazeSlider();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
